import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import DecisionTree from './DecisionTree';
import Disclaimer from './disclaimer';

const DisclaimerButton: React.FC = () => (
  <a
    href="/disclaimer"
    className="disclaimer-fab"
  >
    Disclaimer
  </a>
);

function App() {
  const location = useLocation();
  const isDisclaimerPage = location.pathname === '/disclaimer';
  const isSplashPage = location.pathname === '/' && window.location.hash === '' && document.querySelector('.hero-section');
  return (
    <div className="App">
      <div className="main-content">
        <Routes>
          <Route path="/" element={<DecisionTree />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
      </div>
      {!(isDisclaimerPage || isSplashPage) && <DisclaimerButton />}
    </div>
  );
}

export default function AppWithRouter() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
